var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.188,
    height: 27.248,
    viewBox: "0 0 27.188 27.248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clients",
    transform: "translate(-1126.3 -799.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M1144.7,799.565l-8.708,4.65-.08.043v6l-9.516,3.6-.1.037v12.916h27.188V804.258Zm.005,12.282V825.3h-4.075v-14.7Zm-4.9-3.086-2.384.917v-4.5l7.275-3.905,7.275,3.905V825.3h-5.758V810.684ZM1127.852,825.3V814.964l11.266-4.263v14.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 1.513,
    height: 3.466,
    transform: "translate(1148.264 806.269)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 1.513,
    height: 3.466,
    transform: "translate(1148.264 815.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M1138.4,814.826a.747.747,0,0,0-.572-.1.277.277,0,0,0-.05.013l-8.837,2.306a.768.768,0,0,0,.2,1.506h.03a.387.387,0,0,0,.191-.051l8.806-2.3a.757.757,0,0,0,.237-1.378Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M1137.89,820.077l-8.83.744a.735.735,0,0,0-.692.78l0,.047a.747.747,0,0,0,.74.685h.034l8.89-.745a.752.752,0,0,0,.506-.286.744.744,0,0,0,.155-.558A.755.755,0,0,0,1137.89,820.077Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsIcon);
export default __webpack_public_path__ + "static/media/clientsIcon.205e8064e8332d164362d6c533c1e6c7.svg";
export { ForwardRef as ReactComponent };